import { Logo } from "../iconsComponent"
import './Loader.css'

export const Loader = () => {

    return (
        <div className="loader-cont">
            <div className="loader-row-anim d-flex flex-row">
                <div className="loader-logo h-100 d-flex flex-row align-items-center justify-content-star">
                    <Logo className={"h-100"} colorLogo="#FF3F6B" />
                </div>
                <div className="loader-logo h-100 d-flex flex-row align-items-center">
                    <Logo className={"h-100"} colorLogo="#FF3F6B" />
                </div>
                <div className="loader-logo h-100 d-flex flex-row align-items-center">
                    <Logo className={"h-100"} colorLogo="#FF3F6B" />
                </div>
            </div>
            <div className="loader-row ">
                <div className="w-100 h-100 d-flex flex-row align-items-center justify-content-center">
                    <span>loading</span>
                </div>
            </div>
        </div>
    )
}